import React from 'react';
import './App.css';
import Routes from "./Routes/index";
import './assets/scss/theme.scss';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {
  return (
    <React.Fragment>
    <Routes/>
    <ToastContainer />
  </React.Fragment>
  );
}

export default App;
